import React, { FunctionComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mq } from '@helpers/breakpoints';

interface AnchorDownArrowProps {
  isVisible?: boolean;
  onClick?: () => void;
}

const AnchorDownArrow: FunctionComponent<AnchorDownArrowProps> = (props: any) => {
  const { isVisible, onClick } = props;
  return (
    <FontAwesomeIcon
      icon={['far', 'chevron-down']}
      size="2x"
      css={mq({
        color: 'white',
        borderRadius: '30px',
        backgroundColor: 'lightGray',
        margin: '0 auto',
        padding: '8px 10px',
        opacity: isVisible ? 0.3 : 0,
        display: isVisible ? 'block' : 'none',
        visibility: isVisible ? '' : 'hidden',
        transition: 'visibility 0s 2s, opacity 2s linear',
      })}
      onClick={onClick}
    />
  );
};

export default AnchorDownArrow;
